export default __webpack_public_path__ + "static/media/Ellipse 85.c41e283e.svg";